import { render, staticRenderFns } from "./team-slider.vue?vue&type=template&id=663c36e4&"
import script from "./team-slider.vue?vue&type=script&lang=js&"
export * from "./team-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports